<div class="admin-pending-listings">
  <div class="page-header">
    <div class="header-content">
      <div class="header-left">
        <button class="btn-back" (click)="goBack()">
          <span class="back-icon">⬅️</span>
          Back to Admin
        </button>
        <div class="title-section">
          <h1 class="page-title">Pending Listings Management</h1>
          <p class="page-subtitle">Review and approve submitted listings</p>
        </div>
      </div>
      <div class="header-actions">
        <button class="btn-refresh" (click)="onRefresh()" [disabled]="loading">
          <span class="refresh-icon">🔄</span>
          <span>Refresh</span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="messages.success" class="alert alert-success">
    <span>{{ messages.success }}</span>
    <button class="alert-close" (click)="dismissMessage('success')">×</button>
  </div>

  <div *ngIf="messages.error" class="alert alert-error">
    <span>{{ messages.error }}</span>
    <button class="alert-close" (click)="dismissMessage('error')">×</button>
  </div>

  <div class="filters-section">
    <div class="filters-row">
      <div class="filter-group">
        <label>Category:</label>
        <select
          [(ngModel)]="filters.category"
          (ngModelChange)="onFilterChange()"
          class="filter-select"
        >
          <option *ngFor="let option of categoryOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label>Status:</label>
        <select
          [(ngModel)]="filters.status"
          (ngModelChange)="onFilterChange()"
          class="filter-select"
        >
          <option *ngFor="let option of statusOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="filter-group search-group">
        <label>Search:</label>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearch($event)"
          placeholder="Search listings..."
          class="search-input"
        />
      </div>

      <div class="filter-group" *ngIf="canPerformBulkActions()">
        <button class="btn-bulk-approve" (click)="bulkApproveAll()">
          <span class="btn-icon">✅</span>
          Bulk Approve All
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showBulkActions" class="bulk-actions-bar">
    <div class="bulk-info">
      <span class="selected-count">{{ getSelectedCount() }} selected</span>
    </div>
    <div class="bulk-actions">
      <button
        class="btn-bulk-action approve"
        (click)="approveSelected()"
        [disabled]="processing"
      >
        <span class="btn-icon">✅</span>
        Approve Selected
      </button>
      <button
        class="btn-bulk-action decline"
        (click)="declineSelected()"
        [disabled]="processing"
      >
        <span class="btn-icon">❌</span>
        Decline Selected
      </button>
      <button class="btn-bulk-action clear" (click)="clearSelection()">
        <span class="btn-icon">🗑️</span>
        Clear Selection
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading pending listings...</p>
  </div>

  <div *ngIf="error && !loading" class="error-container">
    <div class="error-card">
      <h3>Error Loading Listings</h3>
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="onRefresh()">Try Again</button>
    </div>
  </div>

  <div *ngIf="!loading && !error" class="listings-section">
    <div class="listings-header">
      <div class="listings-count">
        Showing {{ listings.length }} of {{ totalItems }} listings
        <span class="page-info"
          >(Page {{ currentPage }} of {{ totalPages }})</span
        >
      </div>
      <div class="items-per-page">
        <label>Items per page:</label>
        <select
          [(ngModel)]="itemsPerPage"
          (ngModelChange)="onFilterChange()"
          class="page-select"
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>
    </div>

    <div class="table-container">
      <table class="listings-table">
        <thead>
          <tr>
            <th class="checkbox-col">
              <input
                type="checkbox"
                [checked]="isAllSelected()"
                (change)="onSelectAll($event)"
                class="select-all-checkbox"
              />
            </th>
            <th>Image</th>
            <th>Title & Category</th>
            <th>Seller</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let listing of listings; trackBy: trackByListingId"
            class="listing-row"
            [class.selected]="isSelected(listing.id.toString())"
          >
            <td class="checkbox-col">
              <input
                type="checkbox"
                [checked]="isSelected(listing.id.toString())"
                (change)="onListingSelect(listing.id.toString(), $event)"
                class="listing-checkbox"
              />
            </td>

            <td class="image-col">
              <img
                [src]="getListingImage(listing)"
                [alt]="listing.title"
                class="listing-thumbnail"
                (click)="viewListing(listing)"
              />
            </td>

            <td class="title-col">
              <div class="listing-title" (click)="viewListing(listing)">
                {{ listing.title }}
              </div>
              <div class="listing-meta">
                <span class="category-badge">{{ listing.category }}</span>
                <span class="subcategory-text">{{ listing.subcategory }}</span>
              </div>
            </td>

            <td class="seller-col">
              <div class="seller-info">
                <div class="seller-name">
                  {{ listing.first_name }} {{ listing.last_name }}
                </div>
                <div class="seller-email">{{ listing.email }}</div>
              </div>
            </td>

            <td class="status-col">
              <span
                class="status-badge"
                [class]="getStatusClass(listing.status)"
              >
                {{ listing.status }}
              </span>
            </td>

            <td class="date-col">
              <div class="date-info">
                <div class="created-date">
                  {{ formatDate(listing.created_at) }}
                </div>
                <div class="view-count">{{ listing.view_count }} views</div>
              </div>
            </td>

            <td class="actions-col">
              <div class="action-buttons">
                <button
                  class="btn-action view"
                  (click)="viewListing(listing)"
                  title="View Details"
                >
                  👁️
                </button>
                <button
                  *ngIf="
                    listing.status === 'pending' ||
                    listing.status === 'declined'
                  "
                  class="btn-action approve"
                  (click)="quickApprove(listing)"
                  title="Approve"
                  [disabled]="processing"
                >
                  ✅
                </button>
                <button
                  *ngIf="
                    listing.status === 'pending' || listing.status === 'active'
                  "
                  class="btn-action decline"
                  (click)="quickDecline(listing)"
                  title="Decline"
                  [disabled]="processing"
                >
                  ❌
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="listings-grid">
      <div
        *ngFor="let listing of listings; trackBy: trackByListingId"
        class="listing-card"
        [class.selected]="isSelected(listing.id.toString())"
      >
        <div class="card-header">
          <input
            type="checkbox"
            [checked]="isSelected(listing.id.toString())"
            (change)="onListingSelect(listing.id.toString(), $event)"
            class="listing-checkbox"
          />
          <span class="status-badge" [class]="getStatusClass(listing.status)">
            {{ listing.status }}
          </span>
        </div>

        <div class="card-content" (click)="viewListing(listing)">
          <div class="listing-image">
            <img [src]="getListingImage(listing)" [alt]="listing.title" />
          </div>

          <div class="listing-info">
            <h3 class="listing-title">{{ listing.title }}</h3>
            <div class="listing-meta">
              <span class="category-badge">{{ listing.category }}</span>
              <span class="subcategory-text">{{ listing.subcategory }}</span>
            </div>

            <div class="seller-info">
              <div class="seller-name">
                {{ listing.first_name }} {{ listing.last_name }}
              </div>
              <div class="seller-email">{{ listing.email }}</div>
            </div>

            <div class="listing-stats">
              <span class="created-date">{{
                formatDate(listing.created_at)
              }}</span>
              <span class="view-count">{{ listing.view_count }} views</span>
            </div>
          </div>
        </div>

        <div class="card-actions">
          <button
            class="btn-action view"
            (click)="viewListing(listing)"
            [disabled]="processing"
          >
            <span class="btn-icon">👁️</span>
            View
          </button>
          <button
            *ngIf="
              listing.status === 'pending' || listing.status === 'declined'
            "
            class="btn-action approve"
            (click)="quickApprove(listing)"
            [disabled]="processing"
          >
            <span class="btn-icon">✅</span>
            Approve
          </button>
          <button
            *ngIf="listing.status === 'pending' || listing.status === 'active'"
            class="btn-action decline"
            (click)="quickDecline(listing)"
            [disabled]="processing"
          >
            <span class="btn-icon">❌</span>
            Decline
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="listings.length === 0" class="empty-state">
      <div class="empty-content">
        <div class="empty-icon">📋</div>
        <h3>No Listings Found</h3>
        <p>No listings match your current filters.</p>
      </div>
    </div>

    <div *ngIf="totalPages > 1" class="pagination">
      <button
        class="btn-page"
        [disabled]="currentPage === 1"
        (click)="onPageChange(currentPage - 1)"
      >
        ← Previous
      </button>

      <button
        *ngIf="shouldShowEllipsis('start')"
        class="btn-page"
        (click)="onPageChange(1)"
      >
        1
      </button>

      <span *ngIf="shouldShowEllipsis('start')" class="pagination-ellipsis"
        >...</span
      >

      <button
        *ngFor="let page of getPageNumbers()"
        class="btn-page"
        [class.active]="page === currentPage"
        (click)="onPageChange(page)"
      >
        {{ page }}
      </button>

      <span *ngIf="shouldShowEllipsis('end')" class="pagination-ellipsis"
        >...</span
      >

      <button
        *ngIf="shouldShowEllipsis('end')"
        class="btn-page"
        (click)="onPageChange(totalPages)"
      >
        {{ totalPages }}
      </button>

      <button
        class="btn-page"
        [disabled]="currentPage === totalPages"
        (click)="onPageChange(currentPage + 1)"
      >
        Next →
      </button>
    </div>
  </div>

  <div
    *ngIf="showApproveModal"
    class="modal-overlay"
    (click)="closeApproveModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Approve Selected Listings</h3>
        <button class="modal-close" (click)="closeApproveModal()">×</button>
      </div>

      <div class="modal-body">
        <p>
          You are about to approve
          <strong>{{ getSelectedCount() }}</strong> listing(s).
        </p>

        <div class="form-group">
          <label for="approval-note">Admin Note (Optional):</label>
          <textarea
            id="approval-note"
            [(ngModel)]="approvalNote"
            placeholder="Add a note for the sellers..."
            class="form-textarea"
            rows="3"
          ></textarea>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeApproveModal()"
          [disabled]="processing"
        >
          Cancel
        </button>
        <button
          class="btn-modal approve"
          (click)="confirmApprove()"
          [disabled]="processing"
        >
          <span *ngIf="processing">Approving...</span>
          <span *ngIf="!processing">Approve Listings</span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showDeclineModal"
    class="modal-overlay"
    (click)="closeDeclineModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Decline Selected Listings</h3>
        <button class="modal-close" (click)="closeDeclineModal()">×</button>
      </div>

      <div class="modal-body">
        <p>
          You are about to decline
          <strong>{{ getSelectedCount() }}</strong> listing(s).
        </p>

        <div class="form-group">
          <label for="decline-reason">Reason for Decline (Required):</label>
          <textarea
            id="decline-reason"
            [(ngModel)]="declineReason"
            placeholder="Please provide a reason for declining these listings..."
            class="form-textarea"
            rows="4"
            required
          ></textarea>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeDeclineModal()"
          [disabled]="processing"
        >
          Cancel
        </button>
        <button
          class="btn-modal decline"
          (click)="confirmDecline()"
          [disabled]="processing || !declineReason.trim()"
        >
          <span *ngIf="processing">Declining...</span>
          <span *ngIf="!processing">Decline Listings</span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showBulkApproveModal"
    class="modal-overlay"
    (click)="closeBulkApproveModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Bulk Approve All Pending Listings</h3>
        <button class="modal-close" (click)="closeBulkApproveModal()">×</button>
      </div>

      <div class="modal-body">
        <p>
          This will approve <strong>ALL</strong> pending listings in the current
          category filter.
        </p>
        <p class="warning-text">⚠️ This action cannot be undone.</p>

        <div class="form-group">
          <label for="bulk-note">Admin Note (Optional):</label>
          <textarea
            id="bulk-note"
            [(ngModel)]="approvalNote"
            placeholder="Add a note for all sellers..."
            class="form-textarea"
            rows="3"
          ></textarea>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeBulkApproveModal()"
          [disabled]="bulkProcessing"
        >
          Cancel
        </button>
        <button
          class="btn-modal approve"
          (click)="confirmBulkApprove()"
          [disabled]="bulkProcessing"
        >
          <span *ngIf="bulkProcessing">Processing...</span>
          <span *ngIf="!bulkProcessing">Bulk Approve All</span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showQuickDeclineModal"
    class="modal-overlay"
    (click)="closeQuickDeclineModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Decline Listing</h3>
        <button class="modal-close" (click)="closeQuickDeclineModal()">
          ×
        </button>
      </div>

      <div class="modal-body">
        <p *ngIf="currentDeclineListing">
          You are about to decline listing:
          <strong>"{{ currentDeclineListing.title }}"</strong>
        </p>

        <div class="form-group">
          <label for="quick-decline-reason"
            >Reason for Decline (Required - Min 20 characters):</label
          >
          <textarea
            id="quick-decline-reason"
            [(ngModel)]="quickDeclineReason"
            placeholder="Please provide a detailed reason for declining this listing (minimum 20 characters)..."
            class="form-textarea"
            rows="4"
            required
            [class.invalid]="
              quickDeclineReason.length > 0 && !isQuickDeclineReasonValid()
            "
          ></textarea>
          <div
            *ngIf="quickDeclineReason.length > 0"
            class="character-count"
            [class.valid]="isQuickDeclineReasonValid()"
            [class.invalid]="!isQuickDeclineReasonValid()"
          >
            {{ quickDeclineReason.trim().length }}/20 characters
          </div>
        </div>

        <div
          *ngIf="quickDeclineReason.length > 0 && !isQuickDeclineReasonValid()"
          class="warning-text"
        >
          ⚠️ Please provide at least 20 characters explaining the reason for
          decline.
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeQuickDeclineModal()"
          [disabled]="processing"
        >
          Cancel
        </button>
        <button
          class="btn-modal decline"
          (click)="confirmQuickDecline()"
          [disabled]="processing || !isQuickDeclineReasonValid()"
        >
          <span *ngIf="processing">Declining...</span>
          <span *ngIf="!processing">Decline Listing</span>
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="showQuickApproveModal"
    class="modal-overlay"
    (click)="closeQuickApproveModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Approve Listing</h3>
        <button class="modal-close" (click)="closeQuickApproveModal()">
          ×
        </button>
      </div>

      <div class="modal-body">
        <p *ngIf="currentApproveListing">
          You are about to approve listing:
          <strong>"{{ currentApproveListing.title }}"</strong>
        </p>

        <div class="form-group">
          <label for="quick-approval-note">Admin Note (Optional):</label>
          <textarea
            id="quick-approval-note"
            [(ngModel)]="quickApprovalNote"
            placeholder="Add an optional note for the seller..."
            class="form-textarea"
            rows="3"
          ></textarea>
        </div>
      </div>

      <div class="modal-actions">
        <button
          class="btn-modal cancel"
          (click)="closeQuickApproveModal()"
          [disabled]="processing"
        >
          Cancel
        </button>
        <button
          class="btn-modal approve"
          (click)="confirmQuickApprove()"
          [disabled]="processing"
        >
          <span *ngIf="processing">Approving...</span>
          <span *ngIf="!processing">Approve Listing</span>
        </button>
      </div>
    </div>
  </div>
</div>
